import { useLayoutEffect } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

// Invisible companion field for CatalogsAndSchemasField.
//
// The catalog-name conflict check must *block* the wizard when a requested
// name already exists. Scaffolder blocks a step when a field's `validation`
// callback adds an error, but that callback is only reliably invoked for
// scalar (string) fields: the `catalogs` field is an array, and the resolved
// schema for an array field drops the custom `ui:field` keyword, so its
// validation callback never runs. This hidden string field provides a
// dependable validation hook (see CatalogConflictGuardFieldExtension in
// ./extensions) that reads the requested catalogs from the form data and the
// looked-up existing catalogs from the shared store.
//
// The field renders nothing; it only needs to exist in the form data so the
// validator is invoked. Its value includes the current catalog names, which
// forces Scaffolder to refresh validation after edits.
export const CatalogConflictGuardField = ({
  onChange,
  formData,
  formContext,
}: FieldExtensionComponentProps<string>) => {
  const catalogs = formContext?.formData?.catalogs ?? [];
  const validationKey = JSON.stringify(catalogs);
  const expectedValue = `ready:${validationKey}`;

  useLayoutEffect(() => {
    if (formData !== expectedValue) {
      onChange(expectedValue);
    }
  }, [expectedValue, formData, onChange]);

  return null;
};
